import type { TFunction } from 'i18next';

/**
 * REV-715: display labels for @afixt/afixt-tests content categories.
 *
 * The API sends the catalog's `content_category` verbatim, and it is the join
 * key everywhere else, so it stays verbatim on the wire. Some values are not
 * fit to show ("DYN") and some are not fit to be translation keys ("Images and
 * other non-text content"), so each maps to a stable key under
 * `contentCategories.*` in the locale files.
 *
 * `Uncategorized` is the API's bucket for rules the catalog does not know
 * (revenant-api ruleTaxonomy.UNCATEGORIZED).
 */
export const CONTENT_CATEGORY_KEYS: Readonly<Record<string, string>> = Object.freeze({
  ARIA: 'aria',
  CSS: 'css',
  DYN: 'dynamicContent',
  'Document Structure': 'documentStructure',
  Forms: 'forms',
  Frames: 'frames',
  'Images and other non-text content': 'images',
  Keyboard: 'keyboard',
  Language: 'language',
  Media: 'media',
  Mobile: 'mobile',
  Navigation: 'navigation',
  Tables: 'tables',
  Timeouts: 'timeouts',
  Uncategorized: 'uncategorized',
});

/**
 * The label to show for a content category. A category with no label is shown
 * as sent: the API may learn a category before the UI does, and an unpolished
 * heading is better than a missing group.
 */
export function contentCategoryLabel(t: TFunction, category: string): string {
  const key = CONTENT_CATEGORY_KEYS[category];
  return key ? t(`contentCategories.${key}`, category) : category;
}
